import React from 'react'
import { IconToggle } from 'react-mdl'

export const hasMark = state => state.marks.some(mark => mark.type === 'bold')

export const markStrategy = state =>
  state.transform().toggleMark('bold').focus().apply()

const Node = ({ children }) => (
  <b>
    {children}
  </b>
)

const Schema = {
  marks: {
    bold: Node,
  },
}

const KeyboardShortcut = (event, data, state) => {
  if (data.isMod && data.key === 'b') return markStrategy(state)
  return
}

const Button = ({ state, onChange }) => (
  <IconToggle
    name="format_bold"
    onChange={() => onChange(markStrategy(state))}
    checked={hasMark(state)}
  />
)

const Plugin = () => ({
  schema: Schema,

  onKeyDown(...args) {
    return KeyboardShortcut(...args)
  },
})

export { Button as BoldButton, Plugin as BoldPlugin }



// WEBPACK FOOTER //
// ./src/components/Editor/plugins/Bold.js